module.exports = __webpack_public_path__ + "img/a5.0a16db2a.jpg";